import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  copyText (event) {
    const dataset = event.currentTarget.dataset
    const copyIconId = `${dataset.copyType}-${dataset.id}`
    const successIconId = `success-${copyIconId}`
    navigator.clipboard.writeText(dataset.copyText)
      .then(() => {
        document.getElementById(copyIconId).classList.add('d-none')
        document.getElementById(successIconId).classList.remove('d-none')
        setTimeout(() => {
          document.getElementById(copyIconId).classList.remove('d-none')
          document.getElementById(successIconId).classList.add('d-none')
        }, 3000)
      })
      .catch(() => {
        alert('コピーに失敗しました')
      })
  }
}
